<script lang="ts">
  import { Route, route_for } from "$lib/route_list";
  import type { definitions } from "$lib/types/supabase";
  import AlgoUseHeader from "./AlgoUseHeader.svelte";

  export let algo_use: definitions["algo_uses"];
  export let size_px = 48;
  export let external_link = false;
</script>

<div class="card mb-5">
  <div class="card-image" />
  <div class="card-content has-background-white-bis">
    <AlgoUseHeader {size_px} {algo_use} />

    <div class="content">
      {algo_use.description || ""}
      <br />
      {#if external_link}
        <a href={route_for(Route.docs, algo_use.slug)} target="_blank">Docs</a>
      {:else}
        <a href={route_for(Route.docs, algo_use.slug)}>Docs</a>
        <!-- else content here -->
      {/if}
    </div>
  </div>
  {#if $$slots.footer}
    <footer class="card-footer">
      <slot name="footer" />
    </footer>
  {/if}
</div>
